import React from 'react';
import classNameBind from 'classnames/bind';

import Label from '../../../Label';
import Stack from '../../../Stack';
import Icon from '../../../Icon';
import styles from './LabelElement.module.css';

const bindClasses = classNameBind.bind(styles);

const LabelElement = ({
  section,
  withAccordion,
  accordionOnClick,
}) => {
  if (!withAccordion) {
    return <Label type="section">{section.section}</Label>;
  }

  return (
    <div
      className={bindClasses('button')}
      role="button"
      tabIndex={0}
      onClick={() => { accordionOnClick(section); }}
      data-ppuc-id="MenuSidebar.accordion.button"
    >
      <Stack spacing="narrow">
        <Stack.Item>
          <div className={bindClasses('accordion-icon-wrapper')}>
            <Icon
              name={section.accordionClosed ? 'chevron-right' : 'chevron-down'}
              color="gray"
            />
          </div>
        </Stack.Item>
        <Stack.Item>
          <Label type="section">
            {section.section}
          </Label>
        </Stack.Item>
      </Stack>
    </div>
  );
};

export { LabelElement };
